import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IWhatMakesCourseDifferent {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  title?: string;
  pre_title?: string;
  pre_title_color?: string;
  title_text_color?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_gradient_angle?: string;
  sub_title?: string;
  sub_title_text_color?: string;
  description?: string;
  description_text_color?: string;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  right_navigation_icon?: string;
  alt_right_nav_icon?: string;
  left_navigation_icon?: string;
  alt_left_icon?: string;
  point_1?: string;
  point_1_text_color?: string;
  point_1_icon?: string;
  point_1_icon_alt?: string;
  point_2?: string;
  point_2_text_color?: string;
  point_2_icon?: string;
  point_2_icon_alt?: string;
  cta_text?: string;
  cta_text_color?: string;
  cta_start_color?: string;
  cta_end_color?: string;
  cta_gradient_angle?: string;
  cta_background_color?: string;
  cta_icon?: string;
  cta_icon_alt?: string;
  background_color?: string;
  carousel_button_color?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createWhatMakesCourseDifferent(payload: Partial<IWhatMakesCourseDifferent>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.WHAT_MAKES_COURSE_DIFFERENT.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateWhatMakesCourseDifferent(id: number, payload: Partial<IWhatMakesCourseDifferent>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.WHAT_MAKES_COURSE_DIFFERENT.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

